var $ = require('jquery');
var carousel = require('./Carousel/carousel');
var matchHeight = require('./MatchHeight/matchheight');
var Map = require('./Map/map');
var inlineSVG = require('inline-svg');
require('jquery-selectric');


$(function(){
	Map(window.__CONFIG__.google_api_key);
	matchHeight();
	carousel();

	if($(window).width() > 800){
		inlineSVG.init({
		  svgSelector: 'img.svg', // the class attached to all images that should be inlined
		  initClass: 'js-inlinesvg', // class added to <html>
		}, function () {
		  console.log('All SVGs inlined');
		});
	}

	$('select').selectric();
	$('body').on('change', 'select#nf-field-9', function(){
		if($(this).val() == '') {
			$(this).css({
				'color': '#777'
			});
		} else {
			$(this).css({
				'color': '#000'
			});
		}
	});

	$('.member-filters__filters select').on('change', function () {
    	var url = $(this).val(); // get selected value
	    if (url) { // require a URL
	        window.location = url; // redirect
	    }
	    return false;
	});

	$('.case_study-pdf').on('click', function(e){
		e.preventDefault();
		var link = $(this).attr('href');
		caseStudyPopup(link, 'pdf');
	});
	$('.case_study-video').on('click', function(e){
		e.preventDefault();
		var link = $(this).attr('href');
		caseStudyPopup(link, 'video');
	});
	function caseStudyPopup(link,datatype){
		$('.case_study-download').attr('href', link);
		$('.case_study_preview').attr('data-type', datatype);
		$('.case_study_preview').show();
		if(datatype == 'video'){
			$('#case_study_video').attr('src', link);
			setTimeout(function(){
				document.getElementById('case_study_video').play();
			},500);
		}else{
			$('.case_study_preview iframe').attr('src', link);
		}
		
	}
	$('.case_study_preview p').on('click', function(){
		document.getElementById('case_study_video').pause();
		$('.case_study_preview').hide();
	});

});